import React, { useEffect, useState } from 'react'
import { aedLogoStyle, eFormButtonsContainer, eformTerms, getDirhamImage, iconContainer, showIconsContainer, termsTitle } from '../../common/cssclasses'
import { useTranslate } from '../../components/TranslationText'
import ShowEntryHorseCard from '../../components/showEntry/ShowEntryHorseCard';
import CustomPopUp from '../../components/CustomPopUp';
import NetaqInput from '../../components/NetaqInput';
import SubmitServiceBtn from '../../components/servicesButtons/SubmitServiceBtn';
import EahsForm from '../../components/EahsForm';
import { useLocation } from 'react-router';
import axiosInstance from '../../axios/axios';
import ApproveAndPayLaterBtn from '../../components/servicesButtons/ApproveAndPayLaterBtn';
import { getAuctionEntryDetials, GetAuctionHorsesRequests } from './apis/AuctionEntryApis';
import AuctionEntryHorseCard from '../../components/AuctionEntry/AuctionEntryHorseCard';

export default function AuctionEntryCheckoutPage({ toast }) {
    const UMBRACOURL = process.env.REACT_APP_UMBRACO;
    const BaseURL = process.env.REACT_APP_BASE_URL;
    const { translate } = useTranslate();
    const userId = localStorage.getItem('currentSubAccountId') ?? '';
    const lang = localStorage.getItem('eahsLang') ?? 'en';
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const auctionId = searchParams.has("auctionId")
        ? searchParams.get("auctionId")
        : "";


    const [horsesList, setHorseList] = useState([]);
    const [auctionDetails, setAuctionDetails] = useState({});
    const [acceptTerms, setAcceptTerms] = useState(false);



    useEffect(() => {
        getAuctionEntryDetials(auctionId).then((res) => {

            setAuctionDetails(res)
            if (!res?.termsAndConditions) {
                setAcceptTerms(true)
            }
        })
        GetAuctionHorsesRequests(userId, auctionId).then((res) => {
            const formattedData = res.map((horse) => ({
                name: horse?.horseName,
                regNr: horse?.registerNumber,
                birthDate: horse?.birthDate,
                birthDateObject: horse?.birthDateObject,
                gender: horse?.gender,
                countryName: horse?.countryName,
                origin: horse?.countryName,
            }))
            setHorseList(formattedData)
        })
    }, [])

    const pendingPayment = horsesList;
    const totalAmount = pendingPayment.length * auctionDetails?.horseFees;
    const loggedInUser = localStorage.getItem("EAHSUserID");


    function submitHorses(isOnlinePayment = true) {
        var returnUrl = `${BaseURL}/profile?activeTab=paymentHistory`;
        if (auctionDetails?.horseFees <= 0) {
            returnUrl = `${BaseURL}/profile?activeTab=auctionEntry`
        }

        const encodeURI = encodeURIComponent(returnUrl);
        window.location.href = `${UMBRACOURL}/BackofficePayment/PaymentGetway?entityId=${auctionId}&paymentType=4&userId=${loggedInUser}&returnUrl=${encodeURI}`;
    }




    return (
        <div className='row rtl'>
            <h2 className={termsTitle}>
                {auctionDetails?.name}
            </h2>
            <div className={showIconsContainer}>
                <div className={iconContainer}>
                    <img src={getDirhamImage(lang)} alt='AED' style={aedLogoStyle} />
                    <span>{`${translate("web.horseFees", "Horse Fees")} ${auctionDetails?.horseFees?.toLocaleString('en-US')} ${translate('web.aed', 'AED')}`}</span>
                </div>
                <div className={iconContainer}>
                    <i className=" fa-solid fa-chess-knight C89C66" />
                    <span>{`${translate('web.selectedHorses', 'Selected Horses')} ${pendingPayment.length}`}</span>
                </div>
            </div>
            {pendingPayment.length > 0 && <>
                <h3 className='fw-bold'>
                    {translate('web.totalToPay', 'Total to Pay')} ({pendingPayment.length})
                </h3>
                {pendingPayment.map((horse, index) => (

                    <div className='col-md-3 col-sm-6 col-12'>
                        <AuctionEntryHorseCard key={`horse${index}`} showId={'12313123'} horse={horse} onClick={() => { }} isSelectedTab={true} />
                    </div>
                ))}
            </>}
            {!!auctionDetails?.termsAndConditions &&
                <div className={eformTerms}>
                    <CustomPopUp
                        key={'terms'}
                        trigger={
                            <NetaqInput
                                key={'termsAndConditions' + "123"}
                                type='checkbox'
                                name='termsAndConditions'
                                label={translate('web.iAgreeToTheTermsAndConditions', 'I Agree To The Terms And Conditions')}
                                checked={acceptTerms}
                                onChange={(e) => setAcceptTerms(e?.target?.checked)}
                            />
                        }
                        title={translate('web.termsAndConditions', 'Terms And Conditions')}
                        content={
                            <>
                                <div dangerouslySetInnerHTML={{ __html: auctionDetails?.termsAndConditions }} />
                            </>
                        }
                    />
                </div>
            }

            <h3 className={'fw-bold mb-main'}>
                {translate('web.total', 'Total')}: {totalAmount} {translate('web.aed', 'AED')}
            </h3>

            <div className={eFormButtonsContainer}>
                <SubmitServiceBtn disabled={!acceptTerms} onClick={() => submitHorses(true)} key={'submit'} />
            </div>
        </div>
    )
}
